export { default, ContentWrapper, TitleWrapper } from './component'
